import styled from 'styled-components';
import { RadioGroup } from '@mui/material';
import { themeMUI } from '../../../../../../../theme/theme';

export const SelectFieldsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  span {
    white-space: nowrap;
  }
`;

export const MarkersLabel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

export const RadioExtraContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;


export const RadioGroupStyled = styled(RadioGroup)<{
  error?: boolean;
}>(({ error }) => ({
  fontSize: '16px',
  lineHeight: '150%',
  gap: '8px',
  letterSpacing: '0.15px',
  display: 'flex',
  width: '100%',

  paddingBottom: 4,
  borderColor: error ? themeMUI.palette.error.main
    : undefined,

  '& .MuiRadio-root': {
    color: error ? themeMUI.palette.error.main : undefined,
  },
}));

